<!-- 房源详情 -->
<template>
  <div class="home">
    <div class="content">
      <div class="Breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/news/Immigration' }"
            >房源列表</el-breadcrumb-item
          >
          <el-breadcrumb-item>房源详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="header">
        <div class="banner">
          <div class="carousel-container">
            <div class="big-image">
              <img
                src="@/assets/leftArrow.png"
                class="arrow left-arrow"
                alt=""
                @click="prevImage"
              />
              <img
                :src="images[currentIndex]"
                :width="291"
                :height="291"
                alt="大图"
              />
              <img
                src="@/assets/rightArrow.png"
                class="arrow right-arrow"
                alt=""
                @click="nextImage"
              />
              <div class="image-index">
                {{ currentIndex + 1 }}/{{ images.length }}
              </div>
            </div>
            <div class="thumbnail-list">
              <div
                v-for="(image, index) in visibleThumbnails"
                :key="index"
                class="thumbnail-item"
                :class="{ active: currentIndex === thumbnailStart + index }"
                @click="changeImage(thumbnailStart + index)"
              >
                <img :src="image" :width="64" :height="64" alt="缩略图" />
              </div>
            </div>
            <!-- 添加指示点 -->
            <div class="indicator-dots">
              <div
                v-for="(dot, index) in dotCount"
                :key="index"
                class="dot"
                :class="{ active: index === currentDotIndex }"
                @click="changeThumbnailGroup(index)"
              ></div>
            </div>
          </div>
          <div class="block">
            <el-carousel height="238px">
              <el-carousel-item v-for="(item, index) in images" :key="index">
                <img :src="item" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="model">
          <div class="model_header">
            <div class="moder_headerL">
              <h1>兰乔帕迪斯｜独栋</h1>
              <div class="location">
                <img src="@/assets/locataion.png" alt="" />
                <p>大阪</p>
              </div>
            </div>

            <div class="money">614.4<span>万</span></div>
          </div>

          <div class="row-container">
            <!-- 左侧三列 -->
            <div class="left">
              <table>
                <thead>
                  <tr>
                    <th>户型</th>
                    <th>单价</th>
                    <th>楼层(共2层)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>3室1厅1卫</td>
                    <td>61379元/平米</td>
                    <td>高层</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- 右侧三列 -->
            <div class="right">
              <table>
                <thead>
                  <tr>
                    <th>建筑面积</th>
                    <th>朝向</th>
                    <th>装修</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>100.1平米</td>
                    <td>东西南北</td>
                    <td>精装修</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="information1">
        <h1>房源信息</h1>
        <div class="information1_box">
          <ul>
            <li>建筑年代<span>2025年</span></li>
            <li>有无电梯<span>无</span></li>
            <li>产权性质<span>个人产权</span></li>
            <li>住在类别<span>普通住宅</span></li>
          </ul>
          <ul>
            <li>建筑结构<span>平层</span></li>
            <li>建筑类别<span>板楼</span></li>
            <li>挂牌时间<span>2025-04-11</span></li>
          </ul>
        </div>
        <div class="sellingPoints">
          <h2>核心卖点</h2>
          <div class="fuwenben">
            丰中位于大阪府北部，是一座充满活力的城市。它l、丰富的文化历史、迷人的自然风光以及享誉全球的教育机构而闻名。拥有完善的交通网络，可通往大阪市中心和日本其他地区3还是日本著名大学之一的大阪大学所在地，同时也拥有众多公立和使其成为探索京都、神户奈良等城市的便捷基地。谷居民。东丰中就是城市内的“隐藏式高端住宅区”之一。私立的小学和中学。丰中一直吸引着当地名人和富。
            步入式衣帽问，鞋柜，2个停车位 士地面积:150.7㎡房屋面积:100.1㎡
            -楼:56.4㎡ 二楼:43.6m 建筑结构:木结构
          </div>
        </div>
      </div>
      <div class="information1 BT" style="margin-top: 30px">
        <h1>房源信息</h1>
        <div class="img_box">
          <div class="img" v-for="(item, index) in 6" :key="index">
            <img src="@/assets/img_box0.png" alt="" />
            <span>户型图</span>
          </div>
        </div>
      </div>
      <div class="statement">
        免妻声明:房源信息由网站用户提供，其真实性、合法性由信息提供者负妻，最终以政府部门登记备案为准，本网站不声明或保证内容之正确性和可靠性，购买该房屋时，请谨情核查，入学情况仅凭历史经验总结，在此不承诺升学事宜。请您在签订合同之前，切勿支付任何形式的费用，以免上当受骗。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      images: [
        require("@/assets/list0.png"),
        require("@/assets/list1.png"),
        require("@/assets/list2.png"),
        // require("@/assets/list3.png"),
        // require("@/assets/list2.png"),
        // require("@/assets/list3.png"),
        // require("@/assets/list4.png"),
        // require("@/assets/list5.png"),
        // require("@/assets/list5.png"),
        // require("@/assets/list5.png"),
        // require("@/assets/list5.png"),
        // require("@/assets/list5.png"),
        // require("@/assets/list5.png"),
        // require("@/assets/list5.png"),
        // require("@/assets/list5.png"),
      ],
      currentIndex: 0, // 当前显示的图片索引
      thumbnailStart: 0, // 缩略图起始索引，用于控制可见的缩略图范围
      visibleThumbnailsCount: 4, // 可见的缩略图数量
    };
  },
  computed: {
    // 计算属性，用于获取当前应该显示的缩略图列表
    visibleThumbnails() {
      const start = this.thumbnailStart;
      const end = Math.min(
        start + this.visibleThumbnailsCount,
        this.images.length
      );
      return this.images.slice(start, end);
    },
    // 计算指示点数量
    dotCount() {
      return Math.ceil(this.images.length / this.visibleThumbnailsCount);
    },
    // 当前激活的指示点索引
    currentDotIndex() {
      return Math.floor(this.currentIndex / this.visibleThumbnailsCount);
    },
  },
  methods: {
    prevImage() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
      this.updateThumbnailStart();
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
      this.updateThumbnailStart();
    },
    changeImage(index) {
      this.currentIndex = index;
      this.updateThumbnailStart();
    },
    // 切换缩略图组
    changeThumbnailGroup(groupIndex) {
      this.thumbnailStart = groupIndex * this.visibleThumbnailsCount;
      this.currentIndex = this.thumbnailStart;
    },
    // 更新缩略图起始位置
    updateThumbnailStart() {
      const groupIndex = Math.floor(
        this.currentIndex / this.visibleThumbnailsCount
      );
      this.thumbnailStart = groupIndex * this.visibleThumbnailsCount;
    },
  },
};
</script>

<style scoped lang="less">
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 75rem;
}
@media (max-width: 576px) {
  .Breadcrumb {
    margin-top: 0 !important;
  }
  .header {
    flex-direction: column;
    padding-top: 0 !important;
    margin-bottom: 15px !important;
    .banner {
      margin-right: 0 !important;
      .block {
        display: block !important;
      }
    }
    .model {
      margin-top: 11px;
      padding: 0 15px 15px;
      border-bottom: 5px solid #f7f7f7;
      .model_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .location {
          margin-bottom: 0;
          img {
            width: 14px;
            height: 14px;
          }
          p {
            font-size: 14px;
          }
        }
        .money {
          font-size: 22px;
          span {
            font-size: 12px !important;
          }
        }
      }
      .row-container {
        // display: none !important;
        overflow-x: scroll; // 允许横向滚动
        overflow-y: hidden; // 隐藏竖向滚动
        white-space: nowrap; // 防止内容换行
        -webkit-overflow-scrolling: touch; // 优化 iOS 滚动体验
        border: none !important;
        padding-bottom: 6px;
        margin-top: 10px !important;
        .left,
        .right {
          width: 100%;
        }
      }
      h1 {
        font-size: 16px !important;
        margin-bottom: 10px !important;
      }
    }
  }
  .information1 {
    h1 {
      margin-left: 18px !important;
      width: 64px !important;
      font-size: 16px !important;
      padding: 0 0 15px !important;
    }
    .information1_box {
      padding: 15px 18px !important;
      padding-bottom: 5px !important;
      flex-direction: row !important;
      justify-content: space-between;
      border-bottom: none !important;
      ul {
        display: flex;
        flex-direction: column;
        margin-bottom: 0 !important;
        // margin-right: 30px;
        li {
          width: 100% !important;
          margin-bottom: 10px;
        }
      }
    }
    .sellingPoints {
      margin-left: 0 !important;
      margin: 0 15px !important;
      border-top: 1px solid #dddddd;
      h2 {
        margin: 15px 0 10px !important;
      }
    }
    .img_box {
      padding: 15px !important;
      gap: 7px !important;
      .img {
        span {
          bottom: 6px;
          left: 7px;
          width: 46px;
          height: 18px;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 5px;
          font-size: 10px;
          line-height: 18px;
        }
        img {
          border-radius: 1.91px;
        }
      }
    }
  }
  .statement {
    margin: 0 15px;
    width: auto !important;
  }
  .BT {
    border-top: 5px solid #f7f7f7;
    padding-top: 15px;
  }
  .el-breadcrumb {
    display: none !important;
  }
  .carousel-container {
    display: none !important;
  }
}
.Breadcrumb {
  margin-top: 30px;
  ::v-deep .el-breadcrumb__inner {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #3d3d3d;
  }
  ::v-deep .is-link {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #3d3d3d;
  }
}
.header {
  display: flex;
  padding-top: 30px;
  box-sizing: border-box;
  margin-bottom: 35px;
  .banner {
    // margin-top: 30px;
    margin-right: 97px;
    .carousel-container {
      max-width: 524px;
      // margin-right: 35px;
    }
    .block {
      display: none;
    }
    .big-image img {
      width: 524px;
      height: 332px;
      object-fit: cover;
      border-radius: 6px;
    }
    .big-image {
      position: relative;
      border-radius: 0;
      .arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 36px;
        height: 67px;
        // border-radius: 0px 6px 6px 0px;
        // opacity: 0.33;
        outline: none;
        border: none;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 10;
        font-size: 24px;
        &.left-arrow {
          left: 0px; // 调整到适合的位置
          border-radius: 0px 6px 6px 0px;
        }
        &.right-arrow {
          right: 0px; // 调整到适合的位置
          border-radius: 6px 0px 0px 6px;
        }
      }

      .image-index {
        position: absolute;
        bottom: 15px;
        left: 15px;
        width: 50px;
        height: 23px;
        background: #000000;
        border-radius: 8px;
        opacity: 0.33;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
      }
    }
    .thumbnail-list {
      display: flex;
      justify-content: flex-start;
      margin-top: 20px;
      overflow: hidden;
    }

    .thumbnail-item {
      cursor: pointer;
      transition: border-color 0.3s ease;
      margin-right: 27px;
    }

    .thumbnail-item img {
      width: 111px;
      height: 70px;
      object-fit: cover;
      border-radius: 0;
    }
    /* 添加指示点样式 */
    .indicator-dots {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;
      .dot {
        width: 31px;
        height: 2px;
        background: rgba(0, 0, 0, 0.2);
        // margin: 0 4px;
        cursor: pointer;
        // transition: background-color 0.3s;
        &.active {
          background: #026af9;
        }
      }
    }
    .article {
      width: 100%;
      h1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #0c1223;
        text-align: left;
        border-bottom: 1px solid #f5f5f5;
        padding-bottom: 15px;
        width: 100%;
      }
      .body {
        display: flex;
        flex-direction: column;
        ul {
          display: flex;
          width: 100%;
          margin-top: 15px;
          li {
            display: flex;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;

            text-align: left;
            span {
              color: rgba(12, 18, 35, 0.5);
            }
            p {
              color: rgba(12, 18, 35, 1);
            }
          }
        }
      }
      .permission {
        display: flex;
        width: 588px;
        height: 84px;
        background: #fafafa;
        border-radius: 6px 6px 6px 6px;
        // padding: 25px 0;
        align-items: center;
        margin-top: 15px;
        li {
          flex: 1;
          display: flex;
          flex-direction: column;
          border-right: 1px solid #dddddd;
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #1c1d25;
            text-align: center;
            margin-bottom: 10px;
          }
          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #606060;
            line-height: 17px;
            text-align: center;
          }
        }
        li:last-child {
          border-right: 0;
        }
      }
    }
  }
  .model {
    display: flex;
    flex-direction: column;

    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #0c1223;
      text-align: left;
      margin-bottom: 5px;
    }
    .location {
      display: flex;
      align-items: center;
      margin-bottom: 35px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #0c1223;
      }
    }
    .money {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      color: #d70000;
      line-height: 39px;
      text-align: left;
      span {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .row-container {
      display: flex;
      border: 0.5px solid #f1f1f1;
      margin-top: 20px;
    }
    .left,
    .right {
      width: 50%; /* 调整宽度以适应布局 */
      display: flex;
      flex-direction: column;

      table {
        display: flex;
        // border-collapse: collapse;
        tr {
          display: flex;
          flex-direction: column;

          th,
          td {
            line-height: 35px;
            height: 35px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 12px;
            color: #545e6b;
            text-align: center;
            border: 0.5px solid #f1f1f1;
          }
          th {
            background: rgba(241, 241, 241, 0.5);
            width: 115px;
          }
          td {
            width: 150px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
.information1 {
  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #026af9;
    padding: 0 18px 23px;
    border-bottom: 3px solid #026af9;
    text-align: left;
    width: 108px;
    box-sizing: border-box;
    margin-left: 30px;
  }
  .information1_box {
    display: flex;
    flex-direction: column;
    padding: 30px;
    box-sizing: border-box;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    ul {
      display: flex;
      li {
        width: 25%;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: rgba(12, 18, 35, 0.5);
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        span {
          color: #121212;
          margin-left: 25px;
        }
      }
    }
    ul:first-child {
      margin-bottom: 15px;
    }
  }
  .sellingPoints {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    h2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: rgba(12, 18, 35, 0.5);
      text-align: left;
      margin: 30px 0 10px;
    }
    .fuwenben {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #121212;
      text-align: left;
    }
  }
  .img_box {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    border-top: 1px solid #dddddd;
    padding: 30px 30px 35px;
    span {
      position: absolute;
      bottom: 15px;
      left: 15px;
      width: 82px;
      height: 30px;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 6px;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 30px;
      text-align: center;
    }
    .img {
      position: relative;
      width: 100%;
      max-width: 560px;
      // height: 355px;
    }
    img {
      width: 100%;
      border-radius: 6.3px;
    }
  }
}
.statement {
  width: 100%;
  padding: 15px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #dddddd;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #0c1223;
  line-height: 22px;
  text-align: left;
}
</style>
